import React from 'react'

import PropTypes from 'prop-types'

import { Button, Typography, Box } from '@material-ui/core'
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded'
import { Link as RouterLink } from 'react-router-dom'

import style from './ResetPasswordSuccessMessage.module.scss'

/**
 * Component to show after successfully resetting the password
 */
const ResetPasswordSuccessMessage = ({ returnLocation }) => {
  return (
    <div className={style.ResetPasswordSuccessMessage}>
      <Box mb={4} color="success.main">
        <CheckCircleRoundedIcon className={style.SuccessIcon} color="inherit" />
      </Box>
      <Typography paragraph>
        If an account with the email you provided exists in our system,
        we've sent you a link to reset your password. Check your email
        and follow the instructions. Check your spam or junk folder if
        you can’t see the message in your inbox.
      </Typography>
      <Typography paragraph color="textSecondary">
        If you have used Wix SSO to create your account, please use the
        "Continue with Wix" button on the sign in screen. You won't receive
        a password reset email from us.
      </Typography>

      <Button
        component={RouterLink}
        to={returnLocation}
        variant="outlined"
        color="primary"
        size="large"
        className={style.ActionButton}
      >
        Go to Sign In
      </Button>

    </div>
  )
}

ResetPasswordSuccessMessage.propTypes = {
  returnLocation: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
}

export default ResetPasswordSuccessMessage
